import { useEffect, useCallback, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Hook per prevenire uscita con modifiche non salvate
 * 
 * @param {boolean} hasChanges - Se ci sono modifiche non salvate
 * @param {string} message - Messaggio da mostrare
 * @returns {Object} { setHasChanges, confirmNavigation }
 */
export function useUnsavedChanges(initialHasChanges = false, message = 'Hai modifiche non salvate. Vuoi davvero uscire?') {
  const [hasChanges, setHasChanges] = useState(initialHasChanges)

  // Previeni chiusura tab/browser
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasChanges) {
        e.preventDefault()
        e.returnValue = message
        return message
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [hasChanges, message])

  // Funzione per confermare navigazione
  const confirmNavigation = useCallback((callback) => {
    if (hasChanges) {
      const confirmed = window.confirm(message)
      if (confirmed) {
        setHasChanges(false)
        callback?.()
        return true
      }
      return false
    }
    callback?.()
    return true
  }, [hasChanges, message])

  return { hasChanges, setHasChanges, confirmNavigation }
}

export default useUnsavedChanges
